import { ArrowRight } from 'lucide-react';
import { bio, skills, identity, photo } from '../mock';

export default function About() {
  return (
    <section id="about" className="relative py-[50px]">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <p className="reveal font-hand text-[26px] md:text-[30px] mb-3" style={{ color: 'var(--terracotta-deep)' }}>
          a little about me
        </p>

        <div className="grid md:grid-cols-[1.25fr_1fr] gap-10 md:gap-16 items-start">
          <div className="reveal reveal-delay-1 order-2 md:order-1">
            <h2 className="font-display text-[40px] md:text-[56px] leading-[1.05] mb-7 md:mb-9" style={{ color: 'var(--ink)' }}>
              I design with <em className="italic" style={{ color: 'var(--terracotta)' }}>intention</em>— and a little paint on my sleeves.
            </h2>
            <div className="space-y-5 text-[16.5px] leading-[1.75]" style={{ color: 'var(--ink-soft)' }}>
              {bio.map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </div>

            <a
              href={identity.resume}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 mt-7 font-medium whitespace-nowrap group"
              style={{ color: 'var(--terracotta-deep)' }}
            >
              <span className="link-underline">Check my resume here</span>
              <ArrowRight size={16} className="shrink-0 transition-transform group-hover:translate-x-0.5" />
            </a>

            {/* Skills */}
            <div className="mt-10 md:mt-12">
              <div className="flex flex-wrap gap-2.5">
                {skills.map((s) => (
                  <span key={s} className="chip font-body">{s}</span>
                ))}
              </div>
            </div>
          </div>

          {/* Photo placeholder */}
          <div className="reveal reveal-delay-2 order-1 md:order-2 md:pt-4">
            <div className="relative">
              <div
                className="relative rounded-[22px] overflow-hidden shadow-warm-lg"
                style={{
                  aspectRatio: '3/4',
                  background:
                    'linear-gradient(160deg, #E8C9A8 0%, #C4622D 55%, #7A3E1E 100%)',
                }}
              >
                <img
                  src={photo}
                  alt="Ritika Ghosh"
                  className="absolute inset-0 w-full h-full object-cover"
                  loading="lazy"
                />
                {/* warm tonal overlay for cohesion */}
                <div className="absolute inset-0 pointer-events-none" style={{
                  background: 'linear-gradient(180deg, rgba(196,98,45,0.06) 0%, rgba(42,31,20,0.18) 100%)',
                }} />
                {/* Corner handwritten tape label */}
                <span
                  className="absolute top-4 left-4 font-hand text-[15px] px-3 py-1 rounded-md rotate-[-4deg]"
                  style={{ background: 'rgba(250,246,238,0.92)', color: 'var(--ink)' }}
                >
                  hi, that&apos;s me
                </span>
              </div>
              <p className="font-hand mt-4 text-[22px] text-right pr-2" style={{ color: 'var(--ink-soft)' }}>
                Mumbai, currently
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
